"use strict";
/**
 * 拷贝对象属性
 *
 * ### Example
 * ```
 * const a = {};
 * const b = {
 *     name: 'coder',
 *     age: 20,
 *     tel: '13000000000'
 * };
 * asassignProp({
 *     target: a,
 *     source: b,
 *     props: ['name', 'age', {
 *          tel: phone
 *     }]
 * })
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
function assignProp(config) {
    var target = config.target, source = config.source;
    config.props.forEach(function (item) {
        if (typeof item === 'string') {
            item in source && (target[item] = source[item]);
        }
        else {
            Object.keys(item).forEach(function (key) {
                key in source && (target[item[key]] = source[key]);
            });
        }
    });
}
exports.assignProp = assignProp;
